import api from './axios';

export interface User {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phone?: string;
    role: string;
    isVerified: boolean;
    isActive: boolean;
    createdAt?: string;
    updatedAt?: string;
    // Frontend specific or join fields
    lastLogin?: string;
    avatar?: string;
}

export interface UpdatePasswordDto {
    currentPassword?: string;
    newPassword?: string;
    confirmNewPassword?: string;
}

export const getUsers = async (): Promise<User[]> => {
    const response = await api.get('/users/all-users');
    return response.data.data;
};

export const getMyProfile = async (): Promise<User> => {
    const response = await api.get('/users/me');
    return response.data;
};

export const createUser = async (userData: Partial<User>): Promise<User> => {
    const response = await api.post('/users/add-user', userData);
    return response.data.data;
};

export const updateUser = async (id: string, userData: Partial<User>): Promise<User> => {
    const response = await api.patch(`/users/edit/${id}`, userData);
    return response.data.data;
};

export const updatePassword = async (id: string, passwordData: UpdatePasswordDto): Promise<void> => {
    // Note: The backend controller uses @Patch('me/password') which likely uses req.user.id
    // But verify if we need to pass ID or if the endpoint ignores it.
    // The snippet provided: @Patch('me/password') ... updateMyPassword(@Request() req ... )
    // So it uses the token's user ID. We should use that specific endpoint.
    await api.patch('/users/me/password', passwordData);
};

export const deleteUser = async (id: string): Promise<void> => {
    await api.delete(`/users/delete/${id}`);
};
